import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Star, Quote } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Testimonials = ({ category }) => {
  const [testimonials, setTestimonials] = useState([]);

  const fetchTestimonials = useCallback(async () => {
    try {
      const response = await axios.get(`${API}/testimonials?category=${category}`);
      setTestimonials(response.data);
    } catch (error) {
      console.error('Error fetching testimonials:', error);
    }
  }, [category]);

  useEffect(() => {
    fetchTestimonials();
  }, [fetchTestimonials]);

  if (testimonials.length === 0) return null;

  return (
    <div className="py-16 bg-[#EBE5DA] border-y border-[#D7C0A0]" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <h2 className="text-3xl md:text-4xl font-medium text-center mb-12" style={{ fontFamily: 'Playfair Display, serif' }} data-testid="testimonials-title">
          Customer Stories
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-white/60 border border-[#D7C0A0] p-8 relative"
              data-testid={`testimonial-${testimonial.id}`}
            >
              <Quote className="absolute top-4 right-4 w-8 h-8 text-[#B87333]/20" />
              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={`star-${testimonial.id}-${i}`} className="w-4 h-4 fill-[#B87333] text-[#B87333]" data-testid="star-icon" />
                ))}
              </div>
              <p className="text-[#5D4037] leading-relaxed mb-4 italic" data-testid="testimonial-comment">
                "{testimonial.comment}"
              </p>
              <p className="font-medium text-[#2C1810]" data-testid="testimonial-customer-name">
                — {testimonial.customer_name}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Testimonials;